/**
 * Shows either a table or raw JSON.
 */
import {Button} from '@wandb/weave/components/Button';
import React, {useState} from 'react';

import CollapsibleJSONTable from '../../CollapsibleJSONTable';
import {CodeEditor} from '../CodeEditor';
import * as S from './PropertyTable.styles';
import {typedDictToDict} from './utilsJobFile';

type PropertyTableProps = {
  label: string;
  values: any;
};

export const PropertyTable = ({label, values}: PropertyTableProps) => {
  const [displayMode, setDisplayMode] = useState('table');
  const colorTable = displayMode === 'table' ? 'secondary' : 'ghost';
  const colorJson = displayMode === 'table' ? 'ghost' : 'secondary';

  const asDict = typedDictToDict(values, false);

  return (
    <>
      <S.Section>
        <S.SectionTitle>{label}</S.SectionTitle>
        <div>
          <Button variant={colorTable} onClick={() => setDisplayMode('table')}>
            Table
          </Button>
          <Button variant={colorJson} onClick={() => setDisplayMode('json')}>
            JSON
          </Button>
        </div>
      </S.Section>
      {displayMode === 'table' && (
        <S.CollapsibleTable>
          <CollapsibleJSONTable data={asDict} stringifyJsonValue={false} />
        </S.CollapsibleTable>
      )}
      {displayMode === 'json' && (
        <CodeEditor
          value={JSON.stringify(asDict, null, 4)}
          language="json"
          readOnly={true}
        />
      )}
    </>
  );
};
